// Copyright (c) 2017 Deere & Company

import * as claimActions from '../../action-list';
import * as userActions from '../../../user/actions-list';
import Facets, {getDefaultState} from '../state/facets';
import {
    sharedToggleDealerAccountFacetItems,
    sharedUpdateDealerAccountFacetInput,
    sharedUpdateDealerAccountFacetItem
} from '../../../shared/reducers/facets';

import {findMatchingKey} from '../../shared/services/claim-shared-helper';
import {updateList} from '../../../shared/services/list-selections';

const actions = {
    ...claimActions,
    ...userActions
};

const updateDateRangeFacet = (state, action) =>
    Facets.update(state, {
        claimDateRangeFacet: {
            dateRange: {$set: action.dateRange}
        }
    });

const updateDateType = (state, action) =>
    Facets.update(state, {
        dateTypeFacet: {
            $set: findMatchingKey(action.dateType, action.dateTypeCollection)
        }
    });

const resetAllFacets = (state, action) =>
    Facets.update(state, {
        claimDateRangeFacet: {
            dateRange: {
                $set: action.claimDateRange
            }
        },
        claimStatusFacet: {
            selectedClaimStatus: {
                $set: action.claimStatus
            }
        },
        dateTypeFacet: {
            key: {$set: getDefaultState().dateTypeFacet.key}
        },
        dealerAccountsFacet: {
            displayedDealers: {
                $set: action.dealerAccounts
            },
            searchInput: {
                $set: ''
            },
            selectedDealers: {
                $set: action.dealerAccounts
            }
        }
    });

const toggleDealerAccountFacetItems = (state, action) =>

    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedToggleDealerAccountFacetItems(state.dealerAccountsFacet, action)
        }
    });

const toggleClaimStatusFacetItems = (state, action) => {

    const updatedSelectedTypes = state.claimStatusFacet.selectedClaimStatus.length ?
        [] :
        action.allowedStatus;

    return Facets.update(state, {
        claimStatusFacet: {
            selectedClaimStatus: {
                $set: updatedSelectedTypes
            }
        }
    });

};

const updateDealerAccountFacetInput = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetInput(state.dealerAccountsFacet, action)
        }
    });

const updateDealerAccountFacetItem = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetItem(state.dealerAccountsFacet, action)
        }
    });

const updateClaimStatusFacetItem = (state, action) =>
    Facets.update(state, {
        claimStatusFacet: {
            selectedClaimStatus: {
                $set: updateList(
                    action.claimStatus,
                    action.isSelected,
                    'key',
                    state.claimStatusFacet.selectedClaimStatus
                )
            }
        }
    });

const updateDealerAccountItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $merge: {
                allowedDealers: action.allowedDealers,
                displayedDealers: action.allowedDealers,
                isInitialLoad: false,
                selectedDealers: action.allowedDealers
            }
        }
    });

const updateClaimStatusItems = (state, action) =>
    Facets.update(state, {
        claimStatusFacet: {
            isInitialLoad: {$set: false},
            selectedClaimStatus: {$set: action.allowedStatus}
        }
    });

const updateDealers = state =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {
                $set: true
            }
        }
    });

const updateClaimStatus = state =>
    Facets.update(state, {
        claimStatusFacet: {
            isInitialLoad: {
                $set: true
            }
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_ALL_CLAIMS_FILTERS]: resetAllFacets,
        [actions.TOGGLE_ALL_CLAIMS_DEALER_ACCOUNT_FACET_ITEMS]: toggleDealerAccountFacetItems,
        [actions.TOGGLE_ALL_CLAIMS_CLAIM_STATUS_FACET_ITEMS]: toggleClaimStatusFacetItems,
        [actions.UPDATE_ALL_CLAIMS_DATE_RANGE_FACET]: updateDateRangeFacet,
        [actions.UPDATE_ALL_CLAIMS_DATE_TYPE]: updateDateType,
        [actions.UPDATE_ALL_CLAIMS_DEALER_ACCOUNT_FACET_INPUT]: updateDealerAccountFacetInput,
        [actions.UPDATE_ALL_CLAIMS_DEALER_ACCOUNT_FACET_ITEM]: updateDealerAccountFacetItem,
        [actions.UPDATE_ALL_CLAIMS_CLAIM_STATUS_FACET_ITEM]: updateClaimStatusFacetItem,
        [actions.UPDATE_USER_PREFERENCES_ALL_CLAIMS_STATUS]: updateClaimStatus,
        [actions.UPDATE_USER_PREFERENCES_CLAIMS_STATUS]: updateClaimStatus,
        [actions.UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS]: updateDealers,
        [actions.UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS]: updateDealers,
        [actions.SELECT_ALL_CLAIMS_CLAIM_STATUS_FACET_ITEMS]: updateClaimStatusItems,
        [actions.SELECT_ALL_CLAIMS_DEALER_ACCOUNT_FACET_ITEMS]: updateDealerAccountItems
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/all-claims/reducers/facets.js